import { createApiRequest } from "@/lib/api/createApiService";
import { SHARE_SURVEY_ENDPOINTS } from "./share-survey.endpoints";

export const shareSurveyService = {
  inviteSurvey: async (surveyId, payload, options = {}) => {
    if (!surveyId) throw new Error("surveyId is required");
    return createApiRequest({
      url: SHARE_SURVEY_ENDPOINTS.INVITE(surveyId),
      method: "POST",
      body: payload,
      ...options,
    });
  },
  fetchInviteSuggestions: async (params = {}, options = {}) => {
    return createApiRequest({
      url: SHARE_SURVEY_ENDPOINTS.INVITE_SUGGESTIONS,
      method: "GET",
      body: params,
      ...options,
    });
  },
};
